


























































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Employee, ListEmployeeWithHourSchedule, TimeOffStatus } from "@/api";
/* eslint-disable */
@Component
export default class UserScheduleGrid extends Vue {
  @Prop({ default: () => [] }) days!: any[];
  @Prop({ default: () => [] }) employees!: any[];
  @Prop({ default: () => [] }) schedules!: any[];
  @Prop({ default: () => [] }) timeOffRequests!: any[];

  // ─── Dialog state ───────────────────────────────────────────────────────────
  transferDialog = false;
  selectedEmp: any = null;
  selectedDay: any = null;
  selectedAssigneeId: number | null = null;
  submitting = false;
  deleting = false;
  confirmTransferDialog = false;
  transferHoursWarning = "";

  async mounted() {
    const departmentEmployees = this.$store.dispatch(
      "schedule/listEmployeList",
    );

    const transferRequests = this.$store.dispatch(
      "scheduleTransfer/fetchSchedules",
    );
    await Promise.all([departmentEmployees, transferRequests]);
  }

  // ─── Getters ────────────────────────────────────────────────────────────────

  getSchedule(employeeId: number, date: string) {
    const match = this.schedules.find(
      s => s.employeeId === employeeId && s.date === date,
    );
    if (!match) return null;
    return match;
  }

  getScheduleStyle(employeeId: number, date: string) {
    const sched = this.getSchedule(employeeId, date);
    if (!sched) return {};

    let statusColor = "#2196f3"; // ASSIGNED default (blue)
    const statusStr = (sched.data?.status || "").toUpperCase();

    if (sched.data?.isUrgent) {
      statusColor = "#f44336";
    } else if (statusStr === "PENDING" || statusStr === "PENDING_APPROVAL") {
      statusColor = "#ff9800";
    } else if (statusStr === "APPROVED") {
      statusColor = "#4caf50";
    } else if (statusStr === "UNAVAILABLE") {
      statusColor = "#9c27b0";
    } else if (statusStr === "OPEN") {
      statusColor = "#00bcd4";
    } else if (statusStr === "CALLED_OFF" || statusStr === "CANCELLED") {
      statusColor = "#f44336";
    }

    return {
      backgroundColor: statusColor + "20",
      borderLeft: `4px solid ${statusColor}`,
    };
  }

  /** Returns the existing schedule transfer for this emp+date, if any. */
  getExistingTransfer(employeeId: number, date: string) {
    const sched = this.getSchedule(employeeId, date);
    if (!sched?.data?.id) return null;

    const transfers: any[] =
      this.$store.state.scheduleTransfer?.schedules || [];
    return (
      transfers.find(
        t => t.scheduleId === sched.data.id && t.fromAssigneeId === employeeId,
      ) || null
    );
  }

  /** Returns a pending time-off request for this emp+date, if any. */
  getPendingTimeOff(employeeId: number, date: string): any | null {
    return (
      this.timeOffRequests.find(
        (r: any) =>
          r.employeeId === employeeId &&
          r.date === date &&
          r.status === TimeOffStatus.PENDING,
      ) || null
    );
  }

  /** Returns an accepted time-off request for this emp+date, if any. */
  getAcceptedTimeOff(employeeId: number, date: string): any | null {
    return (
      this.timeOffRequests.find(
        (r: any) =>
          r.employeeId === employeeId &&
          r.date === date &&
          r.status === TimeOffStatus.ACCEPTED,
      ) || null
    );
  }

  /** Employees from the directory store, filtered to the current user's
   *  primary department and excluding admins/owners. */
  get departmentColleagues(): ListEmployeeWithHourSchedule[] {
    const self = this.$store.getters[
      "getCurrentEmployeeSelf"
    ] as Employee | null;
    if (!self) return [];

    const myDeptId = self.primaryDepartmentId;
    const selfId = self.id;

    const allEmployees: ListEmployeeWithHourSchedule[] =
      this.$store.state.schedule.employees || [];
    return allEmployees.filter(emp => {
      // Must belong to the same primary department
      if (emp.primaryDepartmentId !== myDeptId) return false;
      // Exclude self
      if (emp.id === selfId) return false;
      // Exclude admins and owners
      if (emp.roles && emp.roles.some(r => r === "admin" || r === "owner")) {
        return false;
      }
      return true;
    });
  }

  get dialogScheduleInfo(): string {
    if (!this.selectedDay || !this.selectedEmp) return "";
    const sched = this.getSchedule(
      this.selectedEmp.id,
      this.selectedDay.fullDate,
    );
    const title = sched?.title || "Shift";
    const date = this.selectedDay.fullDate;
    return `${title} — ${date}`;
  }

  get existingTransfer() {
    if (!this.selectedEmp || !this.selectedDay) return null;
    return this.getExistingTransfer(
      this.selectedEmp.id,
      this.selectedDay.fullDate,
    );
  }

  // ─── Actions ────────────────────────────────────────────────────────────────

  openTransferDialog(emp: any, day: any) {
    this.selectedEmp = emp;
    this.selectedDay = day;
    this.selectedAssigneeId = null;
    this.transferDialog = true;
  }

  closeTransferDialog() {
    this.transferDialog = false;
    this.selectedEmp = null;
    this.selectedDay = null;
    this.selectedAssigneeId = null;
  }

  onSubmitTransferClick() {
    if (!this.selectedAssigneeId || !this.selectedEmp || !this.selectedDay)
      return;

    // Look up total hours for the target assignee from the departmentColleagues list
    const assignee = this.departmentColleagues.find(
      emp => emp.id === this.selectedAssigneeId,
    );
    const totalHours = assignee?.totalHours ?? 0;

    if (totalHours >= 40) {
      const name = assignee
        ? `${(assignee as any).firstName || ""} ${(assignee as any).lastName ||
            ""}`.trim()
        : `Employee #${this.selectedAssigneeId}`;
      this.transferHoursWarning = `${name} already has ${totalHours} scheduled hours this week (at or above the 40-hour limit).`;
      this.confirmTransferDialog = true;
    } else {
      this.submitTransfer();
    }
  }

  confirmTransfer() {
    this.confirmTransferDialog = false;
    this.submitTransfer();
  }

  async submitTransfer() {
    if (!this.selectedAssigneeId || !this.selectedEmp || !this.selectedDay)
      return;

    const sched = this.getSchedule(
      this.selectedEmp.id,
      this.selectedDay.fullDate,
    );
    if (!sched?.data?.id) return;

    this.submitting = true;
    try {
      await this.$store.dispatch("scheduleTransfer/addSchedule", {
        scheduleId: sched.data.id,
        fromAssigneeId: this.selectedEmp.id,
        toAssigneeId: this.selectedAssigneeId,
      });
      this.closeTransferDialog();
    } finally {
      this.submitting = false;
    }
  }

  async deleteTransfer() {
    const transfer = this.existingTransfer;
    if (!transfer?.id || !transfer?.scheduleId) return;

    this.deleting = true;
    try {
      await this.$store.dispatch("scheduleTransfer/removeSchedule", {
        scheduleId: transfer.scheduleId,
        scheduleTransferId: transfer.id,
      });
      this.closeTransferDialog();
    } finally {
      this.deleting = false;
    }
  }

  employeeDisplayName(emp: Employee): string {
    return `${emp.firstName || ""} ${emp.lastName || ""}`.trim();
  }
}
